import { render, staticRenderFns } from "./send-verification-email-page.vue?vue&type=template&id=0748f954"
import script from "./send-verification-email-page.vue?vue&type=script&lang=js"
export * from "./send-verification-email-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports